import React from 'react';
import classnames from 'classnames';

import styles from './styles.module.scss';

const suffixInputField = ({
  input,
  type,
  suffix,
  placeholder = '',
  formErrors,
  wrapperClassname,
  className,
  meta: { touched, error, warning }
}) => {
  return (
    <div className={styles.fieldWrapper}>
      <div
        className={classnames(styles.input, className, {
          [styles.notValid]: error && touched
        })}>
        <input
          className={styles.formControl}
          type={type}
          placeholder={placeholder}
          {...input}
        />
        <span className={styles.suffixContainer}>
          <div className={styles.suffix}>{suffix}</div>
        </span>
      </div>

      {touched &&
        ((error && <span className={styles.error}>{error}</span>) ||
          (warning && <span>{warning}</span>))}
    </div>
  );
};

export default suffixInputField;
